__turbopack_context__.v({
  "icon": "style-module-scss-module__WyX5tq__icon",
  "label": "style-module-scss-module__WyX5tq__label",
  "pill": "style-module-scss-module__WyX5tq__pill",
  "pills": "style-module-scss-module__WyX5tq__pills",
});
